<template>
  <div>
    <v-card :loading="loading" elevation="0" class="rounded-xl">
      <div class="pa-3 pb-0">
        <div class="d-flex align-center justify-space-between">
          <h6 class="mb-0">
            Links
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon v-on="on" left small>mdi-information-outline</v-icon>
              </template>
              <span style="max-width: 200px">
                Links de autenticação do usuário, como criação de conta e
                redefinição de senha.
              </span>
            </v-tooltip>
          </h6>
          <v-btn
            v-if="hasPermission(8) && !data.user?.isCompleted"
            color="primary"
            @click="create"
            icon
            small
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>

        <v-data-table
          :headers="headers"
          :items="data.user.UserToken"
          :no-data-text="loading ? 'Carregando...' : 'Nenhum link encontrado.'"
          sort-by="createdAt"
          sort-desc
          dense
        >
          <template v-slot:item.createdAt="{ item }">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  item.createdAt | date("DD/MM/YYYY HH:mm")
                }}</span>
              </template>
              {{ [item.createdAt] | dateDiff(true) }}
            </v-tooltip>
          </template>
          <template v-slot:item.reason="{ item }">
            {{ types[item.reason] || item.reason }}
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              v-if="item.reason === 'CREATE_ACCOUNT' && item.valid && item.id"
              @click="copy(item)"
              icon
            >
              <v-icon small>mdi-content-copy</v-icon>
            </v-btn>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <client-token-copy :user="data.user" @copy_token="copy" />
    <client-create-token :data="data" @create_token="create" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ClientTokenCopy from "./modal/ClientTokenCopy.vue";
import ClientCreateToken from "./modal/ClientCreateToken.vue";
export default {
  components: { ClientTokenCopy, ClientCreateToken },

  data: () => ({
    headers: [
      { text: "Tipo", value: "reason" },
      { text: "Data de criação", value: "createdAt" },
      { text: "", value: "actions" },
    ],
    types: {
      CREATE_ACCOUNT: "Criação de conta",
      RESET_PASSWORD: "Redefinição de senha",
      WEBAUTHN_REGISTER: "Registro de chave de segurança",
      WEBAUTHN_LOGIN: "Login com chave de segurança",
    },
  }),
  methods: {
    copy(token) {
      console.log("COPY", token);
      this.$root.$emit("copy_token", token);
    },
    create() {
      this.$root.$emit("create_token");
    },

  },

  computed: {
    ...mapGetters("auth", ["hasPermission"]),
  },
  props: {
    data: Object,
    loading: Boolean,
  },
};
</script>

<style></style>
